import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { HospitalInsurance } from './HospitalInsurance';

export const InsuranceForm = (props) => {
  const { init_hospital, insurances } = props;

  return (
    <>
      <div className="accordion-item mt-5">
        <h2 className="accordion-header" id="panelsStayOpen-headingInsurance">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseInsurance" aria-expanded="true" aria-controls="panelsStayOpen-collapseInsurance">
            利用可能な健保一覧
          </button>
        </h2>
        <div id="panelsStayOpen-collapseInsurance" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingInsurance">
          <div className="accordion-body">
            <HospitalInsurance init_hospital={init_hospital} insurances={insurances} />
          </div>
        </div>
      </div>
    </>
  );
};